import { AxiosRequestConfig } from 'axios';
import { methodHasBody } from '@/shared/lib/core/request';
import {
  isFormData,
  isObject,
  isString,
} from '@/shared/lib/core/common';
import { removeEmoji } from '@/shared/lib/core/security';

export function emojiEliminateRequestInterceptor(config: AxiosRequestConfig): void {
  const isRequestCorrect = methodHasBody(String(config.method)) && isObject(config.data);
  const removeEmojiForString = (value: unknown) => (isString(value) ? removeEmoji(value) : value);

  if (!isRequestCorrect) {
    return;
  }

  if (isFormData(config.data)) {
    [...config.data.entries()].forEach(([key, value]) => {
      if (isString(value)) {
        config.data.set(key, removeEmojiForString(value));
      }
    });
  } else {
    config.data = Object.fromEntries(Object.entries(config.data).map(
      ([key, value]: [string, unknown]) => {
        return [key, removeEmojiForString(value)];
      },
    ));
  }
}
